// El momento de mostrar un error en los formularios cortos de Administración (Sprint 3: Usuarios,
// Catálogos, Comité, parámetros). Mismo criterio que `useValidacionCampos` del registro
// (`estandares_frontend.md` §5): nada mientras se escribe por primera vez, el campo se valida al
// SALIR de él, y al enviar se muestran todos. Una vez visible, el error se recalcula en cada tecla.
//
// Las REGLAS no viven aquí: cada formulario calcula en cada render su mapa `campo → mensaje` (o
// `undefined` si está bien) y este hook decide cuáles se enseñan.
import { useCallback, useState } from 'react';

export type ErroresDelFormulario = Record<string, string | undefined>;

export function useErroresAlSalir(errores: ErroresDelFormulario) {
  const [todos, setTodos] = useState(false);
  const [tocados, setTocados] = useState<ReadonlySet<string>>(() => new Set());

  const tocar = useCallback((campo: string) => {
    setTocados((previos) => (previos.has(campo) ? previos : new Set(previos).add(campo)));
  }, []);

  /** Al enviar: se enseñan todos. Devuelve si el formulario está bien. */
  const tocarTodo = useCallback((): boolean => {
    setTodos(true);
    return Object.values(errores).every((e) => !e);
  }, [errores]);

  /** Vuelve al estado inicial (al abrir el formulario otra vez). */
  const reiniciar = useCallback(() => {
    setTodos(false);
    setTocados(new Set());
  }, []);

  const errorDe = (campo: string): string | undefined => (todos || tocados.has(campo) ? errores[campo] : undefined);

  return { errorDe, tocar, tocarTodo, reiniciar };
}
